import CanvasHandler from "./CanvasHandler";
import { Seat, PolygonZone, Table } from "../canvas/selector";
import { FabricEvent } from "../types/FabricCustomType";
import { IObjectSelector } from "../types/HandlerObjectType";
import { isTouchInteraction } from "../utils/InteractionUtil";
import BaseObjectHandler from "./BaseObjectHandler";
import { ObjectSuperTypesEnum, SelectionTypeEnum } from "../enums";

class SelectorHandler extends BaseObjectHandler<IObjectSelector> {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
    this.objectTypes = {
      seat: new Seat(canvasHandler),
      polygonZone: new PolygonZone(canvasHandler),
      table: new Table(canvasHandler),
    };
  }

  public handleClickObject(event: FabricEvent<MouseEvent | TouchEvent>) {
    const isTouch = isTouchInteraction(event);
    if (event.target) {
      const { target: { superType } } = event;
      switch (superType) {
        case ObjectSuperTypesEnum.Row:
        case ObjectSuperTypesEnum.RoundTable:
        case ObjectSuperTypesEnum.RectTable:
          if( event.target?.selectionType && event.target?.selectionType === SelectionTypeEnum.byTable){
            const table = event.target._objects[0];
            if (table) {
              this.setType(ObjectSuperTypesEnum.Table);
              if (isTouch) {
                this.object.activateObjectHover(event, table);
              } else {
                this.object.handleSelectObject(event.target.id, table);
              }
            }
          }
          else{
            const seat = event.subTargets?.find((t: any) => t?.superType === ObjectSuperTypesEnum.Seat);
            if (seat) {
              this.setType(ObjectSuperTypesEnum.Seat);
              if (isTouch) {
                this.object.activateObjectHover(event, seat);
              } else {
                this.object.handleSelectObject(event.target.id, seat);
              }
            }
          }
          break;
        default:
          if (isTouch) this.deactivateObjectHover();
          break;
      }
    } else {
      if (isTouch) this.deactivateObjectHover();
    }
  }
}

export default SelectorHandler;
